export default __webpack_public_path__ + "static/media/group-copy.7acf0c47.svg";